import * as React from 'react';
import {useTranslation} from "react-i18next";
import {data} from "../Store/Data";
import {ProfileFullNames, ProfilePCs} from "../Layout";

interface IProps {
	selectedShortName: string;
	category: string;
}

const FormFields = ({category, selectedShortName}: IProps) => {
	const {t} = useTranslation();
	const ab1 = data('ab1').asBool();
	const bonus = data('bonus').asString();
	const modelName = ProfileFullNames[selectedShortName as keyof typeof ProfileFullNames];

	if (bonus !== "") {
		return <>
			<input type={"hidden"} name="bonus" value={bonus}/>
			<h2 className="text-align-center">{t('Jetzt anmelden und bis zu 250€ in VX-Coins on die erste Aufladung erhalten!')}</h2>
		</>
	}

	if (category === 'videos') {
		return (
			<>
				<input type="hidden" name="bonus" value={ProfilePCs[selectedShortName as keyof typeof ProfilePCs]}/>
				<h2 className="text-align-center">{t('Erhalte ein kostenloses Video von {{modelName}} für die Anmeldung geschenkt!', {modelName})}</h2>
				<p className="text-align-center">{t('Trage deine E-Mail ein und erhalte sofort Zugang zum privaten Fan-Club')}</p>
				{ab1 ?
					<p className="text-align-center">{t('Erstelle dir deinen Account, finde dein Traum-Model und schreib mit ihr Live')}</p>
					:
					<p className="text-align-center">{t('Nach Bestätigung der Handynummer damit der Gutschein nicht beliebig oft verwendet werden kann')}</p>
				}
			</>
		)
	}

	if (category === 'livecams') {
		if (ab1) {
			return <>
				<input type={"hidden"} name="bonus" value="FREE100PROZENTONTOPLIVE"/>
				<h2 className="text-align-center">{t('Jetzt gratis Account erstellen und 100% auf deine erste Aufladung erhalten!')}</h2>
				<p className="text-align-center">{t('Erstelle dir deinen Account, finde dein Traum-Model und schreib mit ihr Live')}</p>
			</>
		}

		return (
			<>
				<input type={"hidden"} name="bonus" value="TRYMENOW"/>
				<h2 className="text-align-center">{t('Jetzt Live-Cam starten und 40€ in VX-Coins geschenkt!')}</h2>
				<p className="text-align-center">{t('Nach Bestätigung der Handynummer damit der Gutschein nicht beliebig oft verwendet werden kann')}</p>
			</>
		)
	}

	if (category === 'chatting') {
		return (
			<>
				<input type="hidden" name="bonus" value="FREE100PROZENTONTOP"/>
				<h2 className="text-align-center">{t(' Erstelle deinen gratis Account und erhalte 10 gratis Nachrichten & 100% auf deine erste Aufladung!')}</h2>
				<p className="text-align-center">{t('Trage deinen Username & E-Mail Adresse ein und wir schicken dir deinen Zugang zu mit dem angewendeten 10 Nachrichten + 100% Gutschein!')}</p>
			</>
		)
	}

	return null;
};

export default FormFields
